var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.393,
    height: 79.035,
    viewBox: "0 0 91.393 79.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document",
    transform: "translate(0 -17.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72222",
    "data-name": "Path 72222",
    d: "M85.062,17.081H6.331A6.338,6.338,0,0,0,0,23.412V76.826a6.338,6.338,0,0,0,6.331,6.331H52.24l-1.386,8.454a3.654,3.654,0,0,0,5.511,3.97l9.9-5.213a2.083,2.083,0,0,1,1.314,0l9.9,5.213a4.417,4.417,0,0,0,2.052.534,3.475,3.475,0,0,0,2.051-.649A3.842,3.842,0,0,0,83,91.61l-1.386-8.454h3.448a6.338,6.338,0,0,0,6.331-6.331V23.412A6.338,6.338,0,0,0,85.062,17.081ZM66.927,72.306A11.033,11.033,0,1,1,77.96,61.273,11.046,11.046,0,0,1,66.927,72.306Zm3.184,13.26a7.322,7.322,0,0,0-6.369,0l-7,3.686,2.226-13.58a16.418,16.418,0,0,0,15.923,0l.867,5.294c0,.009,0,.018,0,.027l1.354,8.259Zm15.855-8.74a.917.917,0,0,1-.9.9H80.724l-.991-6.044c0-.024-.01-.047-.015-.071a16.459,16.459,0,1,0-25.582,0c0,.024-.011.047-.015.07l-.992,6.049c-.03,0-.06,0-.09,0H6.331a.917.917,0,0,1-.9-.9V23.412a.917.917,0,0,1,.9-.9H85.062a.917.917,0,0,1,.9.9Z",
    fill: "#263757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72223",
    "data-name": "Path 72223",
    d: "M95.329,60.243h-61.5a2.713,2.713,0,1,0,0,5.426h61.5a2.713,2.713,0,1,0,0-5.426Z",
    transform: "translate(-19.862 -27.548)",
    fill: "#263757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72224",
    "data-name": "Path 72224",
    d: "M59.878,100.911H33.832a2.713,2.713,0,0,0,0,5.426H59.878a2.713,2.713,0,1,0,0-5.426Z",
    transform: "translate(-19.862 -53.505)",
    fill: "#263757"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.c027390454ac98b0f9d29d77d19aaf16.svg";
export { ForwardRef as ReactComponent };